var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter-design-container",class:_vm.backgroundClass,style:([_vm.backgroundStyle, { fontFamily: _vm.localSelectedFont }])},[_c('h1',{staticClass:"counter-text",style:(_vm.colorStyle)},[_vm._v(_vm._s(_vm.localCount))])])}
var staticRenderFns = []

export { render, staticRenderFns }